import { ChangeEventHandler, FocusEventHandler } from "react";

import CustomInput from "./CustomInput";

export type Option = {
  label: string;
  value: string;
  disabled?: boolean;
};

type SelectInputProps = {
  defaultLabel?: string;
  disableDefault?: boolean;
  disabled?: boolean;
  options: Option[];
  value: string;
  onChange: ChangeEventHandler<HTMLSelectElement>;
  onBlur?: FocusEventHandler<HTMLElement>;
  label?: string;
  id?: string;
  name?: string;
  error?: string;
  required?: boolean;
  skipBlankOption?: boolean;
};

const SelectInput = (props: SelectInputProps) => {
  const {
    defaultLabel,
    disableDefault,
    disabled,
    options,
    value,
    onChange,
    onBlur,
    label,
    id,
    name,
    error,
    required,
    skipBlankOption,
  } = props;
  return (
    <CustomInput id={id} label={label} error={error}>
      <select
        value={value === null ? undefined : value}
        id={id || undefined}
        name={name}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
      >
        {!skipBlankOption && (
          <option value="" disabled={disableDefault} hidden={disableDefault}>
            {defaultLabel || "..."}
          </option>
        )}
        {options.map((option: Option) => (
          <option
            key={option.label}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
    </CustomInput>
  );
};

export default SelectInput;
